export type DigitalQuestionTypes = DigitalQuestion['type'];

export enum QuestionTypeV2 {
  MultiChoice = 'MultiChoice',
  SingleChoice = 'SingleChoice',
  NumberRange = 'NumberRange',
  String = 'String',
  Ratio = 'Ratio',
  ChoiceWithText = 'ChoiceWithText',
  SingleChoiceWithText = 'SingleChoiceWithText',
  MultiChoiceWithText = 'MultiChoiceWithText',
}

export interface QuestionBase {
  id: number;
  text: string;
  digitalSurveyId: number;
  digitalSectionId?: number; // null for DRT
  isContextQuestion?: boolean;
  sortIndex: number;
  placeholder?: string;
  hideAggregation?: boolean;
}

export interface ChoiceQuestionPayload {
  id: number;
  text: string;
}

export interface ChoiceWithTextPayload {
  multi: boolean;
  options: ChoiceWithTextPayloadOptions[];
}
export interface ChoiceWithTextPayloadOptions {
  id: number;
  text: string;
  textBox: boolean;
  placeholder?: string;
  isTNA?: boolean;
  textBoxInputRequired?: boolean;
}

export interface QuestionMultiChoice extends QuestionBase {
  type: QuestionTypeV2.MultiChoice;
  payload?: ChoiceQuestionPayload[];
}

export interface QuestionSingleChoice extends QuestionBase {
  type: QuestionTypeV2.SingleChoice;
  payload?: ChoiceQuestionPayload[];
}

export interface QuestionNumberRange extends QuestionBase {
  type: QuestionTypeV2.NumberRange;
}

export interface QuestionString extends QuestionBase {
  type: QuestionTypeV2.String;
}

export interface QuestionRatio extends QuestionBase {
  type: QuestionTypeV2.Ratio;
}

export interface QuestionChoiceWithText extends QuestionBase {
  type: QuestionTypeV2.ChoiceWithText;
  payload?: ChoiceWithTextPayload;
}

export interface QuestionSingleChoiceWithText extends QuestionBase {
  type: QuestionTypeV2.SingleChoiceWithText;
  payload?: ChoiceWithTextPayloadOptions[];
}

export interface QuestionMultiChoiceWithText extends QuestionBase {
  type: QuestionTypeV2.MultiChoiceWithText;
  payload?: ChoiceWithTextPayloadOptions[];
}

export type DigitalQuestion = QuestionMultiChoice |
  QuestionSingleChoice | QuestionString | QuestionRatio |
  QuestionNumberRange | QuestionChoiceWithText | QuestionSingleChoiceWithText |
  QuestionMultiChoiceWithText;
